import React, { Component } from "react";
import { observer } from "mobx-react";
import { AxiosResponse } from "axios";
import { getRequest } from "../../utils/httpRequest";
import GiftWrapper from "./components/GiftWrapper";
import GiftStore from "../../stores/GiftStore";
import GiftReactions from "../../stores/GiftStore/GiftReactions";
import { Gift } from "../../stores/GiftStore/Types";

interface Props {
  match: any;
}

interface State {}

class CourseGift extends Component<Props, State> {
  giftStore = new GiftStore();

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.giftStore.loading();
  }

  render() {
    const { state } = this.giftStore;
    const slug = this.props.match.params.slug;
    const createUrl = `/api/courses/${slug}/gift`;
    const defaultsUrl = `/api/courses/${slug}/gift/defaults`;
    const newUrl = `/api/courses/${slug}/gift/new.json`;
    const quoteUrl = `/api/courses/${slug}/gift/quote.json`;

    return (
      <div className="gifts course">
        <GiftWrapper
          state={state}
          store={this.giftStore}
          defaultsUrl={defaultsUrl}
          quoteUrl={quoteUrl}
          kind="course"
        />
        <GiftReactions
          store={this.giftStore}
          createUrl={createUrl}
          newUrl={newUrl}
          defaultsUrl={defaultsUrl}
          kind="course"
        />
      </div>
    );
  }
}

export default observer(CourseGift);
